import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const AppleIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#apple_svg__a)">
      <path
        fill="#000"
        d="M13.439 4.885c.897 0 2.023-.58 2.693-1.353.607-.7 1.05-1.68 1.05-2.658 0-.132-.013-.265-.038-.374-1 .036-2.2.64-2.921 1.45-.57.615-1.088 1.582-1.088 2.572 0 .145.025.29.038.338.063.013.164.025.265.025M10.276 19.5c1.227 0 1.77-.785 3.3-.785 1.556 0 1.897.76 3.263.76 1.34 0 2.238-1.183 3.085-2.343.949-1.328 1.34-2.633 1.366-2.693-.088-.024-2.655-1.027-2.655-3.841 0-2.44 2.023-3.54 2.137-3.624-1.34-1.836-3.377-1.884-3.933-1.884-1.505 0-2.731.87-3.503.87-.834 0-1.934-.822-3.237-.822-2.478 0-4.995 1.957-4.995 5.653 0 2.295.936 4.723 2.087 6.293.986 1.329 1.846 2.416 3.085 2.416"
      />
    </g>
    <defs>
      <clipPath id="apple_svg__a">
        <path fill="#fff" d="M.133 0h25.125v24H.133z" />
      </clipPath>
    </defs>
  </ChakraIcon>
);
